module.exports = __webpack_public_path__ + "static/media/image5.5e5fbe38.jpg";